<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <div class="img swiper-lazy" :style="{backgroundImage: 'url('+item.img+')'}" alt=""></div>

            <div class="swiper-lazy-preloader"></div>
            <div class="swiper-slide-title">
              <h1>{{item.title}}</h1>
              <p>{{item.content}}</p>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    <!-- 产品中心 -->
    <div id="whyChooseUs" class="conatiner-fuild" style="background: #F7F8FC">
      <div class="container">
        <!--<div class="whyChooseUs-title text-center">
          <div class="unit-title-line"></div>
          <p>产品中心</p>
          <p>PRODUCT CENTER</p>
        </div>-->
        <MobileTitle title="产品中心" subTitle="PRODUCT CENTER"></MobileTitle>

        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-3 server-wrapper product-center-item"
               v-for="(item,index) in productCatogoryList"
               :key="index"
               @click="handleProductCatogoryItemClick(item.id, ind)"
               @mouseenter="ProductCatogoryItemClick(index)"
               @mouseleave="ProductCatogoryItemClick(-1)">
            <div :class="['server-block', 'wow', 'slideInUp', productCatogoryItemClickedIndex == index ? 'server-block-active':'']"
                 onmouseenter="this.style.color='#28f';this.style.borderColor='#28f'"
                 onmouseleave="this.style.color='#666';this.style.borderColor='#ccc'">
              <img class="center-block" style="width: 40%;height:auto" :src="productCatogoryItemClickedIndex == index ? item.logoAct : item.logo" alt="logo">
              <p class="text-center" style="margin-bottom:0;margin-top: 40px;">{{item.title}}</p>
              <div class="text-center"
                   v-html="item.content"
                   onmouseenter="this.style.color='#28f'"
                   onmouseleave="this.style.color='#ccc'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 关于我们 -->
    <div id="whyChooseUs" class="container-fuild" style="padding-top: 50px">
      <!--<div class="whyChooseUs-title text-center">
        <div class="unit-title-line"></div>
        <p>关于我们</p>
        <p>ABOUT US</p>
      </div>-->
      <MobileTitle title="关于我们" subTitle="ABOUT US"></MobileTitle>

      <div class="row bigData-container about-us-outer" style="display:flex;justify-content:center">
        <div class="col-xs-12 col-sm-12 col-md-4 wow zoomIn about-us-content" style="padding: 30px">
          <img class="img-responsive" src="@/assets/img/us/gongsi.png" alt="">
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 about-us-content-txt" style="display:flex;flex-direction:column;justify-content:space-between;padding: 30px">
          <div class="about-us-content-txt-wrap">
            <h2 class="bigData-title about-us-title-area" style="margin-top: 0; font-family: Source Han Sans CN; font-weight: bold; font-size: 24px; color: #565656; line-height: 1; ">
              <img class="img-responsive" src="@/assets/img/home/1.png" style="display:inline;margin-right:9px" alt="">
              公司简介
              <small></small>
            </h2>
            <p style="line-height:24px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;秦皇岛富田电气设备有限公司坐落于美丽的海滨城市、环渤海经济圈中心地带—秦皇岛。本公司是专业从事工业电气测控设备，电力仪表的研发，销售为一体的生产型企业。产品广泛应用于石油、石化、煤矿、化工、电力、钢铁、冶金、水泥等领域。</p>
            <p style="line-height:24px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;欢迎各界朋友前来指导，共同发展。</p>
          </div>
          <!--<h2 class="bigData-device">PC &nbsp; Windows系统支持</h2>-->
          <!--<a href="#/contactus" class="btn btn-lg btn-block btn-info about-us-more-btn" style="width: 100px; background: #006DFF; border-radius: 3px; font-weight: 400; font-size: 14px; color: #FFFFFF; line-height: 1;">查看更多</a>-->
          <a @click="contactusShowMore" href="#" class="btn btn-lg btn-block btn-info about-us-more-btn" style="width: 100px; background: #006DFF; border-radius: 3px; font-weight: 400; font-size: 14px; color: #FFFFFF; line-height: 1;">查看更多</a>
        </div>
      </div>
    </div>

    <!-- 热销产品 -->
    <div id="whyChooseUs" class="conatiner-fuild" style="padding: 50px 0; background: #F7F8FC;">
      <div class="container">
        <!--<div class="whyChooseUs-title text-center">
          <div class="unit-title-line"></div>
          <p>热销产品</p>
          <p>HOT PRODUCT</p>
        </div>-->
        <MobileTitle title="热销产品" subTitle="HOT PRODUCT"></MobileTitle>

        <div class="row hot-product-row" style="display:flex;justify-content:center">
          <div class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
               v-for="(item,index) in hotProductList"
               :key="index"
               @click="handleHotProductItemClick(index)"
               @mouseenter="HotProductItemClick(index)"
               @mouseleave="HotProductItemClick(-1)">
            <div :class="['server-block', 'wow', 'slideInUp']"
                 onmouseenter="this.style.border = '2px solid #77B1FF'"
                 onmouseleave="this.style.border='2px solid #00000000'">
              <img class="center-block" style="width: 100%;height:auto" :src="`/static/data/product/${item.img}`" alt="logo">
            </div>
            <p class="text-center" style="margin-bottom:0;margin-top: 40px;" :style="{color: hotProductItemClickedIndex == index ? '#006DFF':'#222222'}">{{item.title}}</p>
          </div>
        </div>
        <!--<div @click="hotProductShowMore" style="width:fit-content; font-weight: 400; font-size: 18px; color: #006DFF; line-height: 32px; border-radius: 3px; border: 1px solid #006DFF;padding: 5px 20px;margin: 0 auto;margin-top: 34px;cursor: pointer">
          查看更多
        </div>-->
        <a @click="hotProductShowMore" href="#" class="btn btn-lg btn-block btn-info about-us-more-btn" style="width: 100px; background: #006DFF; border-radius: 3px; font-weight: 400; font-size: 14px; color: #FFFFFF; line-height: 1; margin: 0 auto;margin-top: 59px; ">查看更多</a>

      </div>
    </div>

    <!-- 行业动态 -->
    <div id="whyChooseUs" class="conatiner-fuild" style="padding: 50px 0;">
      <div class="container">
        <!--<div class="whyChooseUs-title text-center">
          <div class="unit-title-line"></div>
          <p>行业动态</p>
          <p>INDUSTRY TRENDS</p>
        </div>-->
        <MobileTitle title="行业动态" subTitle="INDUSTRY TRENDS"></MobileTitle>

        <!--pc-->
        <div class="row industry-trends-row-pc" style="display:flex;justify-content:center;align-content:center;">
          <div class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
               v-for="(item,index) in industryTrendsList"
               :key="index"
               @mouseenter="handleIndustryTrendsItemClick(index)"
               @mouseleave="handleIndustryTrendsItemClick(-1)">
            <div :class="['server-block', 'wow', 'slideInUp']"
                 style="display:flex;flex-direction:column;justify-content:space-between;height:100%;padding:0;"
                 @click="handleIndustryTrendsDetail(item)"
                 onmouseenter="this.style.background='linear-gradient(180deg, #F5F9FF 0%, #FFFFFF 100%)'"
                 onmouseleave="this.style.background='#fff'">
              <span style="height: 340px;overflow: hidden">
                <div v-if="industryTrendsItemClickedIndex === index" style="width: 100%;height:6px; background: #006DFF; border-radius: 5px 5px 0px 0px;margin: 0 auto;transition:all 0.3s"></div>
                <div v-if="industryTrendsItemClickedIndex !== index" style="width: 0; height: 6px; margin: 0 auto;"></div>
                <span>
                  <h4 style="font-weight: bold; font-size: 20px; line-height: 31px; padding: 0 17px;">{{item.number}}</h4>
                  <h4 style="font-weight: bold; font-size: 20px; line-height: 31px; padding: 0 17px;">{{item.title}}</h4>
                  <p v-html="item.content" style="font-size: 14px; line-height: 24px; margin-top: 10px; margin-bottom: 0; padding: 0 17px;"></p>
                </span>
              </span>

              <p style="font-weight: 400; font-size: 14px; color: #999999; line-height: 33px;padding: 0 17px;">{{item.date}}</p>
            </div>
          </div>
        </div>
        <!--mobile-->
        <div class="industry-trends-row-mobile">
          <div class="item" v-for="(item,index) in industryTrendsList"
               @click="handleIndustryTrendsDetail(item)">
            <div class="left">
              <img class="img" src="@/assets/img/ico-1.png" />
              <div class="title">{{item.title}}</div>
            </div>
            <div class="date">
              {{item.date}}
            </div>
          </div>
        </div>

        <!--<div @click="industryTrendsShowMore" style="width:fit-content; font-weight: 400; font-size: 18px; color: #006DFF; line-height: 32px; border-radius: 3px; border: 1px solid #006DFF;padding: 5px 20px;margin: 0 auto;margin-top: 34px;cursor: pointer">
          查看更多
        </div>-->
        <a @click="industryTrendsShowMore" href="#" class="btn btn-lg btn-block btn-info about-us-more-btn" style="width: 100px; background: #006DFF; border-radius: 3px; font-weight: 400; font-size: 14px; color: #FFFFFF; line-height: 1;margin: 0 auto;margin-top: 59px; ">查看更多</a>
      </div>
    </div>

    <!-- 您身边的IT专家 -->
    <!--<div id="contactUs" class="container-fuild text-center">
      <div class="container contactUs-container wow slideInUp">
        <h1>您身边的IT专家</h1>
        <h3>7x24小时提供出色的IT服务</h3>
        <button class="btn btn-default btn-sm"
                onmouseleave="this.style.borderColor='#ffffff'; this.style.backgroundColor='#ffffff'; this.style.color='#3f3f3f';"
                onmouseenter="this.style.backgroundColor='transparent'; this.style.borderColor='#ffffff'; this.style.color='#ffffff';"
                @click="navToContactPage">
          联系我们
        </button>
        <div class="contactUs-contactWay">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>-->
    <!-- 客户评价 -->
    <!--<div id="customer" class="container-fuild">
      <div class="container customer-container">
        <p class="customer-title text-center">客户评价</p>
        <div class="swiper-container customer-swiper hidden-xs">
          <div class="swiper-wrapper">
            <div class="swiper-slide customer-block"
                 v-for="(item,index) in customerList"
                 :key="index">
              <div class="customer-logo">
                <img class="center-block" :src="item.logo" alt="logo">
              </div>
              <div class="customer-yh">
                <img src="@/assets/img/yinhao_left.png" alt="引号">
              </div>
              <div class="customer-content1">
                <small>{{item.content}}</small>
              </div>
              <div class="customer-content2">{{item.title}}</div>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
        <div class="row visible-xs customer-block">
          <div class="col-xs-12" v-for="(item,index) in customerList" :key="index">
            <div class="customer-logo">
              <img class="center-block" :src="item.logo" alt="logo">
            </div>
            <div class="customer-yh">
              <img src="@/assets/img/yinhao_left.png" alt="引号">
            </div>
            <div class="customer-content1">
              <small>{{item.content}}</small>
            </div>
            <div class="customer-content2">
              <small>{{item.title}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!-- 为什么选择我们 -->
    <!--<div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <p>为什么选择我们的服务</p>
          <p>THE REASON TO CHOOSING US</p>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
               v-for="(item,index) in serverList"
               :key="index">
            <div class="server-block wow slideInUp"
                 onmouseenter="this.style.color='#28f';this.style.borderColor='#28f'"
                 onmouseleave="this.style.color='#666';this.style.borderColor='#ccc'">
              <img class="center-block" :src="item.logo" alt="logo">
              <p class="text-center">{{item.title}}</p>
              <div class="text-center"
                   v-html="item.content"
                   onmouseenter="this.style.color='#28f'"
                   onmouseleave="this.style.color='#ccc'"></div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>
<script>
  import Swiper from "swiper";
  import { WOW } from 'wowjs';
  import MobileTitle from "@/components/mobile-title/mobile-title.vue"
  import { GoTopStatic } from "@/utils/index"
  export default {
    components: {
      MobileTitle
    },
    name: "HomePage",
    data() {
      return {
        productCatogoryItemClickedIndex: -1,
        hotProductItemClickedIndex: -1,
        industryTrendsItemClickedIndex: -1,
        swiperList: [
          {
            img: require("@/assets/img/banner.png"),
            path: "",
            title: '',
            content: '',
          },
          {
            img: require("@/assets/img/banner2.png"),
            path: "",
            title: '',
            content: '',
          },
          {
            img: require("@/assets/img/banner3.png"),
            path: "",
            title: '',
            content: '',
          },
        ],
        productCatogoryList: [...window.PRODUCT_DATA.map((ite, ind) => {
          let logo = "";
          let logoAct = "";
          if (ite.id == 1) {
            logo = require("@/assets/img/home/product_catogary_1.png")
            logoAct = require("@/assets/img/home/product_catogary_1_1.png")
          } else if (ite.id == 2) {
            logo = require("@/assets/img/home/product_catogary_2.png")
            logoAct = require("@/assets/img/home/product_catogary_2_2.png")
          } else if (ite.id == 3) {
            logo = require("@/assets/img/home/product_catogary_3.png")
            logoAct = require("@/assets/img/home/product_catogary_3_3.png")
          }
          return {
            id: ite.id,
            title: ite.typeName,
            logo,
            logoAct,
          }
        }), {
          logo: require("@/assets/img/home/product_catogary_4.png"),
          logoAct: require("@/assets/img/home/product_catogary_4_4.png"),
          title: "更多",
          content: ""
        }],
        hotProductList: window.HOT_PRODUCT_DATA.slice(0, 3),
        industryTrendsList: window.NEWS_DATA.slice(0, 4).map((ite, ind) => {
          return {
            ...ite,
            number: "0" + (ind + 1)
          }
        }),
        customerList: [
          {
            logo: require("@/assets/img/logo_hp.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_kk.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_toyota.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_kk.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_hp.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_toyota.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_kk.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_hp.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_toyota.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_hp.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_kk.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          },
          {
            logo: require("@/assets/img/logo_hp.png"),
            title:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。",
            content:
              "您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。您可以双击这里或者点击编辑按钮来修改内容。您还可以添加图标，按钮，图片等常用元素。"
          }
        ],
        serverList: [
          {
            logo: require("@/assets/img/tel.png"),
            title: "核心优势1",
            content: "<p>由专业客服提供人工服务</p>负责疑难问题和故障受理"
          },
          {
            logo: require("@/assets/img/computer.png"),
            title: "核心优势2",
            content: "<p>利用远程视频工具，提供协助</p>帮助客户进行调试、解决故障"
          },
          {
            logo: require("@/assets/img/qq.png"),
            title: "核心优势3",
            content: "<p>利用企业QQ提供在线解答</p>帮助企业快速准确解决问题和故障"
          },
          {
            logo: require("@/assets/img/skill.png"),
            title: "核心优势4",
            content: "<p>由技术支持工程师，负责问题解答</p>需求受理及故障受理"
          }
        ]
      };
    },
    mounted() {
      /* banner-swiper */
      new Swiper(".banner-swiper", {
        loop: true, // 循环模式选项
        effect: 'fade',
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        // 延迟加载
        lazy: {
          loadPrevNext: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      });
      /* customer-swiper */
      new Swiper(".customer-swiper", {
        loop: true, // 循环模式选项
        slidesPerView: 3,
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true //修改swiper的父元素时，自动初始化swiper
      });
      /* wowjs动画 */
      var wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      })
      wow.init();
    },
    methods: {
      /** 前往联系我们页面 */
      navToContactPage() {

      },
      handleProductCatogoryItemClick(id, ind) {
        let route = {}
        if (ind == this.productCatogoryList.length - 1) {
          route = {
            name: 'software',
          }
        } else {
          route = {
            name: 'software',
            query: {
              typeId: id,
            }
          }
        }
        GoTopStatic()
        this.$router.push(route)
      },
      ProductCatogoryItemClick(ind) {
        this.productCatogoryItemClickedIndex = ind;

      },
      handleHotProductItemClick(ind) {
        let route = {
          name: 'productDetail',
          query: {
            id: this.hotProductList[ind].id,
            pageName: "hot",
            typeId: -1,
            fromPathName: "hotProduct",
            fromPathIndex: 3
          }
        }
        GoTopStatic()
        this.$store.commit("changeHeaderNavActiveIndex", 3)
        this.$router.push(route)
      },
      HotProductItemClick(ind) {
        this.hotProductItemClickedIndex = ind;
      },
      handleIndustryTrendsItemClick(ind) {
        this.industryTrendsItemClickedIndex = ind;

      },
      hotProductShowMore() {
        let route = {
          name: 'hotProduct',
        }
        GoTopStatic()
        this.$store.commit("changeHeaderNavActiveIndex", 3)
        this.$router.push(route)
      },
      contactusShowMore() {
        let route = {
          name: 'contactus',
        }
        GoTopStatic()
        this.$router.push(route)
      },
      handleIndustryTrendsDetail(ite) {
        let route = {
          name: 'newsinformationdetail',
          params: {
            id: ite.id,
          }
        }
        GoTopStatic()
        this.$store.commit("changeHeaderNavActiveIndex", 2)
        this.$router.push(route)

      },
      industryTrendsShowMore() {
        let route = {
          name: 'newsinformation',
        }
        GoTopStatic()
        this.$store.commit("changeHeaderNavActiveIndex", 2)
        this.$router.push(route)

      }
    }
  };
</script>
<style scoped>
  /* 整体盒子 */
  #HomePage {
    width: 100%;
  }

    #HomePage .row {
      margin-top: 25px;
    }
  /* 轮播图 */
  #swiper {
    height: 65vh;
  }

    #swiper .banner-swiper {
      width: 100%;
      height: 100%;
    }

      #swiper .banner-swiper .swiper-slide .img {
        display: block;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
      }

      #swiper .banner-swiper .swiper-slide {
        position: relative;
      }

      #swiper .banner-swiper .swiper-slide-title {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999999999;
        width: 100%;
        height: 100%;
        color: #fff;
        /*background: rgba(51, 51, 51, 0.534);*/
        text-align: center;
        line-height: 80px;
      }

        #swiper .banner-swiper .swiper-slide-title > h1 {
          font-size: 50px;
          margin-top: 12%;
        }

        #swiper .banner-swiper .swiper-slide-title > p {
          font-size: 20px;
          margin-top: 1%;
          font-weight: 700;
        }
  /* 大数据管理系统 */
  #bigData {
    padding: 100px;
    transition: all ease 0.6s;
    box-sizing: border-box;
  }

    #bigData .bigData-title {
      padding-bottom: 10px;
      border-bottom: 1px solid #ccc;
    }

    #bigData p {
      font-size: 14px;
      color: #333;
      line-height: 2rem;
    }

    #bigData .bigData-device {
      margin: 50px 0 20px;
    }

  /* 您身边的IT专家 */
  #contactUs {
    color: #fff;
    height: 400px;
    background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
    background-size: 100% 100%;
    transition: all ease 0.6s;
  }

    #contactUs .contactUs-container {
      padding-top: 50px;
    }

      #contactUs .contactUs-container button {
        width: 300px;
        height: 50px;
        margin-top: 40px;
      }

      #contactUs .contactUs-container .contactUs-contactWay span {
        display: inline-block;
        width: 48px;
        height: 48px;
        margin: 30px;
      }

        #contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
          background: url("../assets/img/weixin.png") 0 0 no-repeat;
          background-size: 100% 100%;
        }

        #contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
          background: url("../assets/img/weibo.png") 0 0 no-repeat;
          background-size: 100% 100%;
        }

        #contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
          background: url("../assets/img/twitter.png") 0 0 no-repeat;
          background-size: 100% 100%;
        }

  /* 客户评价 */
  #customer {
    padding: 50px 0;
    box-sizing: border-box;
    background: #efefef;
    transition: all ease 0.6s;
  }

    #customer .customer-title {
      font-size: 30px;
      color: rgb(102, 102, 102);
      margin: 0 0 30px;
    }

    #customer .customer-block {
      background: #fff;
      padding: 30px;
    }

    #customer .customer-logo img {
      width: 94px;
      height: 94px;
      border: 1px solid #ccc;
    }

    #customer .customer-yh img {
      width: 34px;
      height: 34px;
    }

    #customer .customer-content1 {
      padding-bottom: 20px;
      border-bottom: 1px solid #0ce9f1;
    }

    #customer .customer-content2 {
      padding-top: 20px;
    }
  /* 为什么选择我们 */
  #whyChooseUs {
    padding: 100px;
    padding-top: 44px !important;
  }

    #whyChooseUs .whyChooseUs-title {
      margin-bottom: 50px;
    }

      #whyChooseUs .whyChooseUs-title .unit-title-line {
        width: 55px;
        height: 5px;
        background: #006DFF;
        border-radius: 2px;
        margin: 0 auto;
        margin-bottom: 21px;
      }

      #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
        font-size: 25px;
        font-weight: 500;
      }

      #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
        font-size: 14px;
      }

    #whyChooseUs .server-block {
      box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.1);
      background-color: #fff;
      border-radius: 5px;
      padding: 50px 0px;
      /*border: 1px solid #ccc;*/
      /*border-bottom: 5px solid #ccc;*/
    }

    #whyChooseUs .server-block-active {
      background-color: #006DFF;
    }

      #whyChooseUs .server-block-active p {
        color: #FFFFFF !important;
      }

    #whyChooseUs .server-block img {
      width: 48px;
      height: 48px;
    }

    #whyChooseUs .server-block > p {
      font-size: 20px;
      color: #222222;
      margin: 20px 0;
    }

    #whyChooseUs .server-block > div {
      color: #ccc;
    }

  .industry-trends-row-mobile {
    display: none;
  }
  /* 媒体查询（手机） */
  @media screen and (max-width: 768px) {
    #swiper {
      height: 200px;
    }

    #bigData {
      padding: 30px;
    }

      #bigData .bigData-title {
        font-size: 20px;
      }

      #bigData .bigData-device {
        font-size: 20px;
        margin: 10px 0 10px;
      }

    #contactUs {
      height: 200px;
      transition: all ease 0.6s;
    }

      #contactUs .contactUs-container {
        padding-top: 0;
      }

        #contactUs .contactUs-container h1 {
          font-size: 25px;
        }

        #contactUs .contactUs-container h3 {
          font-size: 18px;
        }

        #contactUs .contactUs-container button {
          width: 200px;
          height: 30px;
          margin-top: 20px;
        }

        #contactUs .contactUs-container .contactUs-contactWay span {
          display: inline-block;
          width: 28px;
          height: 28px;
          margin: 10px;
        }


    #customer {
      padding: 30px 0;
      box-sizing: border-box;
      background: #fff;
    }

      #customer .customer-title {
        font-size: 16px;
        font-weight: bold;
      }

      #customer .customer-logo img {
        width: 48px;
        height: 48px;
      }

      #customer .customer-block {
        padding: 30px;
      }

        #customer .customer-block > div {
          padding: 30px 0;
        }

    #whyChooseUs {
      padding: 20px 0;
      transition: all ease 0.6s;
    }

      #whyChooseUs .row {
        display: grid !important;
        grid-template-columns: calc(50%) calc(50%);
        grid-template-rows: auto auto;
        grid-row-gap: 15px;
        grid-column-gap: 8px;
        margin-left: 0 !important;
        margin-right: 0 !important;
      }

        #whyChooseUs .row::before {
          display: none;
        }

      #whyChooseUs .product-center-item {
        width: calc(100% - 8px);
        padding: 0 !important;
      }

      #whyChooseUs .whyChooseUs-title {
        margin-bottom: 21px;
      }

        #whyChooseUs .whyChooseUs-title .unit-title-line {
          margin-bottom: 7px;
        }

        #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 25px;
          color: #333333;
          line-height: 44px;
          margin-bottom: 0;
        }

        #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
          font-size: 12px;
          color: #999999;
          margin-bottom: 0;
        }

      #whyChooseUs .server-block {
        padding: 20px 0;
        /*border: 1px solid #ccc;*/
        /*border-bottom: 5px solid #ccc;*/
      }

        #whyChooseUs .server-block img {
          width: 30% !important;
        }

        #whyChooseUs .server-block > p {
          font-size: 19px;
          margin: 30px 0;
          margin-top: 20px !important;
        }

        #whyChooseUs .server-block > div {
          color: #ccc;
        }

      #whyChooseUs .about-us-outer {
        display: block !important;
        padding: 20px;
        padding-top: 0;
      }

      #whyChooseUs .about-us-content {
        padding: 0 !important;
      }

      #whyChooseUs .about-us-content-txt {
        padding: 0 !important;
      }

      #whyChooseUs .about-us-title-area {
        display: none;
      }

      #whyChooseUs .about-us-content-txt-wrap {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 2 !important;
        margin-top: 20px;
      }

      #whyChooseUs .about-us-more-btn {
        margin: 0 auto;
        margin-top: 10px;
      }

      #whyChooseUs .hot-product-row {
        display: flex !important;
      }

        #whyChooseUs .hot-product-row .server-wrapper {
          padding: 0 !important;
        }

          #whyChooseUs .hot-product-row .server-wrapper p {
            margin-top: 13px !important;
          }

        #whyChooseUs .hot-product-row .server-block {
        }

          #whyChooseUs .hot-product-row .server-block img {
            width: 99% !important;
            height: 100% !important;
          }

      #whyChooseUs .industry-trends-row-pc {
        display: none !important;
      }

      #whyChooseUs .industry-trends-row-mobile {
        display: block !important;
        margin-top: 20px;
      }

        #whyChooseUs .industry-trends-row-mobile .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #00000011;
          margin-bottom: 1em;
          padding-bottom: 1em;
        }

          #whyChooseUs .industry-trends-row-mobile .item .left {
            display: flex;
            align-items: center;
            width: calc(100% - 100px - 10px - 1px);
          }

            #whyChooseUs .industry-trends-row-mobile .item .left .img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }

            #whyChooseUs .industry-trends-row-mobile .item .left .title {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 17px;
              color: #222222;
              line-height: 1;
              padding-right: 10px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
            }

          #whyChooseUs .industry-trends-row-mobile .item .date {
            width: 100px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #999999;
            line-height: 1;
          }
  }

  /* 媒体查询（平板） */
  @media screen and (min-width: 768px) and (max-width: 996px) {
    #swiper {
      height: 400px;
    }

    #bigData {
      padding: 60px;
    }

      #bigData .bigData-title {
        font-size: 30px;
      }

      #bigData .bigData-device {
        font-size: 30px;
        margin: 30px 0 15px;
      }

    #contactUs {
      height: 300px;
    }

      #contactUs .contactUs-container {
        padding-top: 50px;
      }

        #contactUs .contactUs-container h1 {
          font-size: 30px;
        }

        #contactUs .contactUs-container h3 {
          font-size: 20px;
        }

        #contactUs .contactUs-container button {
          width: 300px;
          height: 50px;
          margin-top: 30px;
        }

        #contactUs .contactUs-container .contactUs-contactWay span {
          display: inline-block;
          width: 32px;
          height: 32px;
          margin: 15px;
        }

    #customer .customer-title {
      font-size: 24px;
    }

    #whyChooseUs {
      padding: 20px 0;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue